<template>
    <div>
        <slot>
            <span
                v-if="selectedText === '' || selectedText === null || selectedText === undefined"
                class="text-muted"
            >
                (not set)
            </span>

            <span v-else>{{selectedText}}</span>
        </slot>
    </div>
</template>

<script>
import OriginalComponent from '../../../SelectInput'

export default {
    name: OriginalComponent.name + '-view',
    extends: OriginalComponent,
    computed: {
        selectedText() {
            for(let i in this.optionsConverted) {
                if( this.optionsConverted[i].value === String(this.selected) ) {
                    return this.optionsConverted[i].text
                }
            }
        }
    }
}
</script>
